import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the withdrawal request table view.
 * @extends JetView
 */
export default class tableWithdrawalRequestView extends JetView {
    /**
     * Configures the UI components of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        const cur_user = this.getParam('user', true); // Get current user parameter

        // Custom data filter for summing column values
        webix.ui.datafilter.mySummColumn = webix.extend(
            {
                refresh: function (master, node, value) {
                    var result = 0; // Initialize result for summation
                    var resultFormat = 0; // Initialize formatted result
                    var size = $$('datatable').getPager().config.size; // Get page size
                    var page = $$('datatable').getPage(); // Get current page
                    var first = size * page; // Calculate first index of current page
                    var last = first + size - 1; // Calculate last index of current page
                    var count = 0; // Initialize count for iteration
                    master.data.each(function (obj) {
                        if (count >= first && count <= last) {
                            result += parseFloat(obj[value.columnId]); // Sum values in the specified column
                        }
                        count++;
                    });
                    resultFormat = webix.i18n.priceFormat(result); // Format the result
                    node.firstChild.innerHTML = resultFormat; // Update the node with formatted result
                },
            },
            webix.ui.datafilter.summColumn, // Extend existing summColumn filter
        );

        return {
            rows: [
                {
                    cols: [
                        {
                            view: 'datatable', // DataTable view
                            id: 'datatable', // Unique ID for the DataTable
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            select: true, // Enable row selection
                            columns: [
                                {
                                    id: 'detailTittle', // Column ID
                                    header: '', // Column header
                                    width: 50, // Column width
                                    height: 25, // Column height
                                    tooltip: 'Detalles', // Tooltip text
                                    template: function (obj) {
                                        return "<span class='webix_icon wxi-close details'></span>"; // Template for detail icon
                                    },
                                    footer: 'Total:', // Footer text
                                },
                                {
                                    id: 'ActionTittle', // Column ID for actions
                                    header: '', // Column header
                                    width: 70, // Column width
                                    height: 25, // Column height
                                    tooltip: 'Acción', // Tooltip text
                                    hidden: !devConfig.getPermAction('withdrawalRequests', 'Edit'), // Hide based on permissions
                                    css: 'prm-withdrawalRequests', // CSS class for styling
                                    template: function (obj) {
                                        // Template for action buttons based on state
                                        if (
                                            obj.State == 'A' &&
                                            obj.AccountBank !== '' &&
                                            obj.AccountBank !== undefined &&
                                            obj.AccountBank !== null
                                        ) {
                                            return "<span placeholder='Aprobar' class='webix_icon wxi-close approve'></span><span class='webix_icon wxi-close torefuse'></span>";
                                        } else if (
                                            obj.State == 'P' &&
                                            obj.AccountBank !== '' &&
                                            obj.AccountBank !== undefined &&
                                            obj.AccountBank !== null
                                        ) {
                                            return "<span placeholder='Pagar' class='webix_icon wxi-close pay'></span>";
                                        } else {
                                            return '';
                                        }
                                    },
                                },
                                {
                                    id: 'CreatedLocal', // Column ID for creation date
                                    header: _('Fecha'), // Column header
                                    width: 150, // Column width
                                    sort: 'int', // Sort type
                                },
                                {
                                    id: 'State', // Column ID for state
                                    header: _('Estado'), // Column header
                                    options: [
                                        // Options for state dropdown
                                        { id: '', value: _('None') },
                                        { id: 'A', value: _('Activado') },
                                        { id: 'C', value: _('Cancelado') },
                                        { id: 'I', value: _('Pagada') },
                                        { id: 'E', value: _('Eliminado') },
                                        { id: 'P', value: _('Pendiente') },
                                        { id: 'R', value: _('Rechazado') },
                                    ],
                                },
                                {
                                    id: 'PaymentDate', // Column ID for payment date
                                    header: _('Fecha Pagado'), // Column header
                                    width: 150, // Column width
                                    sort: 'int', // Sort type
                                },
                                {
                                    id: 'Amount', // Column ID for amount
                                    header: _('Valor'), // Column header
                                    format: webix.i18n.priceFormat, // Formatting function
                                    exportType: 'number', // Export type
                                    width: 100, // Column width
                                    sort: 'int', // Sort type
                                    footer: { content: 'mySummColumn' }, // Footer content using custom summation
                                },
                                {
                                    id: 'Id', // Column ID for ID
                                    header: 'Id', // Column header
                                    width: 70, // Column width
                                    sort: 'int', // Sort type
                                },
                                {
                                    id: 'ClientId', // Column ID for client ID
                                    header: _('ID Cliente'), // Column header
                                    width: 80, // Column width
                                    sort: 'int', // Sort type
                                },
                                {
                                    id: 'WayPay', // Column ID for payment method
                                    header: _('Forma de pago'), // Column header
                                    width: 150, // Column width
                                    sort: 'int', // Sort type
                                },
                                {
                                    id: 'PaymentMethod', // Column ID for payment method
                                    header: _('Método de pago'), // Column header
                                    width: 150, // Column width
                                    sort: 'int', // Sort type
                                },
                                {
                                    id: 'TypeAccount', // Column ID for account type
                                    header: _('Tipo de cuenta'), // Column header
                                    width: 150, // Column width
                                    sort: 'int', // Sort type
                                },
                                {
                                    id: 'AccountBank', // Column ID for bank account
                                    header: _('Cuenta Bancaria'), // Column header
                                    width: 150, // Column width
                                    sort: 'int', // Sort type
                                },
                                {
                                    id: 'CodeInterbank', // Column ID for interbank code
                                    header: _('Código Interbancario'), // Column header
                                    width: 150, // Column width
                                    sort: 'int', // Sort type
                                },
                                {
                                    id: 'Department', // Column ID for department
                                    header: _('Departamento'), // Column header
                                    width: 150, // Column width
                                    sort: 'int', // Sort type
                                },
                                {
                                    id: 'City', // Column ID for city
                                    header: _('Ciudad'), // Column header
                                    width: 150, // Column width
                                    sort: 'int', // Sort type
                                },
                                {
                                    id: 'BetShop', // Column ID for betting shop
                                    header: _('Punto de Venta'), // Column header
                                    width: 150, // Column width
                                    sort: 'int', // Sort type
                                },
                                {
                                    id: 'Ip', // Column ID for IP address
                                    header: 'IP', // Column header
                                    width: 250, // Column width
                                    sort: 'int', // Sort type
                                },
                            ],
                            onClick: {
                                // Event handlers for click actions on the DataTable
                                details: function (euv, id) {
                                    var item = this.getItem(id); // Get the clicked item
                                    this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
                                },
                                pay: function (euv, id) {
                                    var vvthis = this; // Reference to the current context
                                    webix
                                        .modalbox({
                                            title: 'Question', // Modal title
                                            buttons: [
                                                _('Pagar por Sistema'), // Button text
                                                _('Pagado fisicamente'), // Button text
                                                _('Cancelar'), // Button text
                                            ],
                                            text: 'Do you love JS?', // Modal text
                                            width: 500, // Modal width
                                        })
                                        .then(function (result) {
                                            switch (result) {
                                                case '0': // Payment via system
                                                    webix.confirm({
                                                        type: 'confirm-warning', // Confirmation type
                                                        text:
                                                            _('Advertencia!') +
                                                            '<br/>' +
                                                            _('Desea Pagar Nota de Retiro?'), // Confirmation text
                                                        ok: _('Pagar Nota'), // OK button text
                                                        cancel: _('Salir'), // Cancel button text
                                                        callback: function (action) {
                                                            if (action === true) {
                                                                var item = vvthis.getItem(id); // Get the item
                                                                webix
                                                                    .ajax()
                                                                    .headers({
                                                                        'Content-type': 'application/json', // Set content type
                                                                    })
                                                                    .post(
                                                                        devConfig.geturlApi() +
                                                                            'Client/PayWithdrawalRequestsAPI',
                                                                        '{ "Id":' + item.Id + '}', // Payload for the request
                                                                        {
                                                                            error: function (
                                                                                text,
                                                                                data,
                                                                                XmlHttpRequest,
                                                                            ) {
                                                                                webix.message('Error! '); // Show error message
                                                                            },
                                                                            success: function (
                                                                                text,
                                                                                data,
                                                                                XmlHttpRequest,
                                                                            ) {
                                                                                item.State = 'I'; // Update item state
                                                                                webix.message(
                                                                                    'Envio de solicitud de pago. ',
                                                                                ); // Show success message
                                                                                vthis.$$('table').clearAll(); // Clear the table
                                                                                vthis.$$('table').load(url); // Reload the table data
                                                                            },
                                                                        },
                                                                    );
                                                            }
                                                        },
                                                    });
                                                    break;
                                                case '1': // Payment physically
                                                    webix.confirm({
                                                        type: 'confirm-warning', // Confirmation type
                                                        text:
                                                            _('Advertencia!') +
                                                            '<br/>' +
                                                            _('Desea Pagar Nota de Retiro?'), // Confirmation text
                                                        ok: _('Pagar Nota'), // OK button text
                                                        cancel: _('Salir'), // Cancel button text
                                                        callback: function (action) {
                                                            if (action === true) {
                                                                var item = vvthis.getItem(id); // Get the item
                                                                webix
                                                                    .ajax()
                                                                    .headers({
                                                                        'Content-type': 'application/json', // Set content type
                                                                    })
                                                                    .post(
                                                                        devConfig.geturlApi() +
                                                                            'Client/PayWithdrawalRequests',
                                                                        '{ "Id":' + item.Id + '}', // Payload for the request
                                                                        {
                                                                            error: function (
                                                                                text,
                                                                                data,
                                                                                XmlHttpRequest,
                                                                            ) {
                                                                                webix.message('Error! '); // Show error message
                                                                            },
                                                                            success: function (
                                                                                text,
                                                                                data,
                                                                                XmlHttpRequest,
                                                                            ) {
                                                                                item.State = 'I'; // Update item state
                                                                                webix.message('Nota de Retiro Pagada'); // Show success message
                                                                                vthis.$$('table').clearAll(); // Clear the table
                                                                                vthis.$$('table').load(url); // Reload the table data
                                                                            },
                                                                        },
                                                                    );
                                                            }
                                                        },
                                                    });
                                                    break;
                                                case '2': // Cancel action
                                                    break;
                                            }
                                        });
                                },
                                approve: function (euv, id) {
                                    var vvthis = this; // Reference to the current context
                                    webix.confirm({
                                        type: 'confirm-warning', // Confirmation type
                                        text: _('Advertencia!') + '<br/>' + _('Desea Aprobar Nota de Retiro?'), // Confirmation text
                                        ok: _('Aprobar Nota'), // OK button text
                                        cancel: _('Salir'), // Cancel button text
                                        callback: function (action) {
                                            if (action === true) {
                                                var item = vvthis.getItem(id); // Get the item
                                                webix
                                                    .ajax()
                                                    .headers({
                                                        'Content-type': 'application/json', // Set content type
                                                    })
                                                    .post(
                                                        devConfig.geturlApi() + 'Client/AllowWithdrawalRequests',
                                                        '{ "Id":' + item.Id + '}', // Payload for the request
                                                        {
                                                            error: function (text, data, XmlHttpRequest) {
                                                                webix.message('Error! '); // Show error message
                                                            },
                                                            success: function (text, data, XmlHttpRequest) {
                                                                item.State = 'P'; // Update item state
                                                                webix.message('Nota de Retiro Aprobado'); // Show success message
                                                                vthis.$$('table').clearAll(); // Clear the table
                                                                vthis.$$('table').load(url); // Reload the table data
                                                            },
                                                        },
                                                    );
                                            }
                                        },
                                    });
                                },
                                torefuse: function (euv, id) {
                                    var vvthis = this; // Reference to the current context
                                    webix.confirm({
                                        type: 'confirm-warning', // Confirmation type
                                        text: _('Advertencia!') + '<br/>' + _('Desea Rechazar Nota de Retiro?'), // Confirmation text
                                        ok: _('Rechazar Nota'), // OK button text
                                        cancel: _('Salir'), // Cancel button text
                                        callback: function (action) {
                                            if (action === true) {
                                                var item = vvthis.getItem(id); // Get the item
                                                webix
                                                    .ajax()
                                                    .headers({
                                                        'Content-type': 'application/json', // Set content type
                                                    })
                                                    .post(
                                                        devConfig.geturlApi() + 'Client/CancelClientRequests',
                                                        '{ "Id":' + item.Id + '}', // Payload for the request
                                                        {
                                                            error: function (text, data, XmlHttpRequest) {
                                                                webix.message('Error! '); // Show error message
                                                            },
                                                            success: function (text, data, XmlHttpRequest) {
                                                                item.State = 'E'; // Update item state
                                                                webix.message('Nota de Retiro Rechazada'); // Show success message
                                                                vthis.$$('table').clearAll(); // Clear the table
                                                                vthis.$$('table').load(url); // Reload the table data
                                                            },
                                                        },
                                                    );
                                            }
                                        },
                                    });
                                },
                            },
                            on: {
                                // Event handlers for DataTable lifecycle
                                onBeforeLoad: function () {
                                    this.showOverlay(
                                        "<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>",
                                    ); // Show loading overlay
                                },
                                onAfterLoad: function () {
                                    this.hideOverlay(); // Hide loading overlay
                                },
                            },
                            ready: function () {
                                if (!this.count()) {
                                    webix.extend(this, webix.OverlayBox); // Extend with overlay functionality
                                    this.showOverlay(
                                        "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                                            _('No hay datos') +
                                            '</div>',
                                    ); // Show no data overlay
                                }
                            },
                            editable: true, // Enable editing
                            footer: true, // Show footer
                            tooltip: true, // Enable tooltips
                            math: true, // Enable math operations
                            loadahead: devConfig.getDefaultDataFetch(), // Load ahead configuration
                            pager: 'pagerA', // Pager ID
                            url:
                                devConfig.geturlApi() +
                                'es/Client/GetClientWithdrawalRequests?PlayerId=' +
                                cur_user +
                                '&', // Data source URL
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The DataTable instance.
     */
    init(grid) {
        grid = $$('datatable'); // Get the DataTable instance
        const cur_user = this.getParam('user', true); // Get current user parameter
        var url = grid.data.url; // Store the URL for data loading
        var filter = ''; // Initialize filter string

        // Event listener for filtering data
        this.on(this.app, 'bonusReport:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize filter string
            for (var i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - '); // Split date range
                        console.log(date);
                        string1 = string1 + '&dateFrom=' + date[0]; // Add start date to filter
                        string1 = string1 + '&dateTo=' + date[1]; // Add end date to filter
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Convert nested filter data to entries
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]); // Create date object for start date
                                    var dateFrom =
                                        'MinCreatedLocal=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2); // Format start date
                                    string1 = string1 + '&' + dateFrom; // Add start date to filter
                                } else if (object2[j][0] === 'end') {
                                    var d = new Date(object2[j][1]); // Create date object for end date
                                    var dateTo =
                                        'MaxCreatedLocal=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2); // Format end date
                                    string1 = string1 + '&' + dateTo; // Add end date to filter
                                }
                            }
                        }
                    }
                }
            }
            string1 = string1 + '&PlayerId=' + cur_user; // Add current user to filter
            grid.clearAll(); // Clear the grid data
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load filtered data
            filter = string1; // Update filter string
        });

        // Event listener for sorting data
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir); // Load sorted data
        });

        // Event listener for starting edit
        grid.attachEvent('onBeforeEditStart', function (id) {
            var item = this.getItem(id); // Get the item being edited
            console.log(item);
            if (id.column == 'Action') {
                var options = this.getColumnConfig('Action').collection; // Get action column options
                if (item.State == 'A') {
                    options.remove('P'); // Remove payment option if state is 'A'
                } else if (item.State == 'P') {
                    options.remove('A'); // Remove approval option if state is 'P'
                } else {
                    return false; // Prevent editing for other states
                }
                console.log(id);
            }
        });

        // Event listener for stopping edit
        grid.attachEvent('onAfterEditStop', function (state, editor, ignoreUpdate) {
            console.log(state);
            var item = this.getItem(editor.row); // Get the edited item
            console.log(item);
            if (state.value != state.old) {
                // Check if the value has changed
                if (state.value == 'A') {
                    webix
                        .ajax()
                        .headers({
                            'Content-type': 'application/json', // Set content type
                        })
                        .post(
                            devConfig.geturlApi() + 'Client/AllowWithdrawalRequests',
                            '{ "Id":' + item.Id + '}', // Payload for the request
                            {
                                error: function (text, data, XmlHttpRequest) {
                                    webix.message('Error! '); // Show error message
                                },
                                success: function (text, data, XmlHttpRequest) {
                                    item.State = 'P'; // Update item state
                                    webix.message('Cell value was changed'); // Show success message
                                },
                            },
                        );
                }
                if (state.value == 'P') {
                    webix
                        .ajax()
                        .headers({
                            'Content-type': 'application/json', // Set content type
                        })
                        .post(
                            devConfig.geturlApi() + 'Client/PayWithdrawalRequests',
                            '{ "Id":' + item.Id + '}', // Payload for the request
                            {
                                error: function (text, data, XmlHttpRequest) {
                                    webix.message('Error! '); // Show error message
                                },
                                success: function (text, data, XmlHttpRequest) {
                                    item.State = 'I'; // Update item state
                                    webix.message('Cell value was changed'); // Show success message
                                },
                            },
                        );
                }
                if (state.value == 'E') {
                    webix
                        .ajax()
                        .headers({
                            'Content-type': 'application/json', // Set content type
                        })
                        .post(
                            devConfig.geturlApi() + 'Client/CancelClientRequests',
                            '{ "Id":' + item.Id + '}', // Payload for the request
                            {
                                error: function (text, data, XmlHttpRequest) {
                                    webix.message('Error! '); // Show error message
                                },
                                success: function (text, data, XmlHttpRequest) {
                                    item.State = 'E'; // Update item state
                                    webix.message('Cell value was changed'); // Show success message
                                },
                            },
                        );
                }
            }
        });

        // Event listener for player selection
        this.on(this.app, 'player:select', (id) => {
            grid.load(grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + id); // Load data for selected player
        });
    }
}

// FILE DOCUMENTED
